import { ObservableService } from "../services/ObservableService";

const initialState = {
  requests: new Map(),
};

export const networkStore = ObservableService.persistentObservable(
  "networkStore",
  () => initialState,
  0
);
